module.exports = __webpack_public_path__ + "img/caselist10.80769413.jpg";